import { createAction, props } from '@ngrx/store';
import { EmailMessage } from 'src/app/types/aggregate-graph.types';

export enum PatientClinicalNoteActionTypes {
	AddClinicalNoteRequested = '[Component] Add Clinical Note Requested',
	AddClinicalNoteCompleted = '[Effect] Add Clinical Note Completed',
	ClinicalNoteSelected = '[Component] Clinical Note Selected',
	ClinicalNoteDeselected = '[Component] Clinical Note Deselected',
	EditClinicalNoteSelected = '[Component] Edit Clinical Note Selected',
	ExportClinicalNoteRequested = '[Component] Export Clinical Note Requested',
	ExportClinicalNoteCompleted = '[Effect] Export Clinical Note Completed',
	EmailClinicalNoteRequested = '[Component] Email Clinical Note Requested',
	EmailClinicalNoteCompleted = '[Effect] Email Clinical Note Completed',
	UnlockClinicalNoteRequested = '[Component] Unlock Clinical Note Requested',
	UnlockClinicalNoteCompleted = '[Effect] Unlock Clinical Note Completed',
	UpdateClinicalNoteNameRequested = '[Component] Update Clinical Note Name Requested',
	UpdateClinicalNoteNameCompleted = '[Effect] Update Clinical Note Name Completed',
	SetClinicalNoteDocumentWidgetValueRequested = '[Component] Set Clinical Note Document Widget Value Requested',
	SetClinicalNoteDocumentWidgetValueCompleted = '[Effect] Set Clinical Note Document Widget Value Completed',
	AttachmentUploadInitiated = '[Component] Attachment Upload Initiated',
	AttachmentUploadProgressed = '[Component] Attachment Upload Progressed',
	AttachmentUploadCompleted = '[Component] Attachment Upload Completed',
	AttachmentUploadFailed = '[Component] Attachment Upload Failed',
	AttachmentUploadsRemoved = '[Effect] Attachment Uploads Removed',
	AttachmentDownloadInitiated = '[Component] Attachment Download Initiated',
	AttachmentDownloadCompleted = '[Effect] Attachment Download Completed',
	RemoveAttachmentRequested = '[Component] Remove Attachment Requested',
	RemoveAttachmentCompleted = '[Effect] Remove Attachment Completed',
	AllAttachmentsSelected = '[Component] All Attachments Selected',
	AllAttachmentsDeselected = '[Component] All Attachments Deselected'
}

export const addClinicalNoteRequested = createAction(
	PatientClinicalNoteActionTypes.AddClinicalNoteRequested,
	props<{ visitId: string, clinicalNoteDefinitionId: string }>()
)

export const addClinicalNoteCompleted = createAction(
	PatientClinicalNoteActionTypes.AddClinicalNoteCompleted,
	props<{ clinicalNoteId: string }>()
)

export const clinicalNoteSelected = createAction(
	PatientClinicalNoteActionTypes.ClinicalNoteSelected,
	props<{ clinicalNoteId: string }>()
)

export const clinicalNoteDeselected = createAction(
	PatientClinicalNoteActionTypes.ClinicalNoteDeselected
)

export const editClinicalNoteSelected = createAction(
	PatientClinicalNoteActionTypes.EditClinicalNoteSelected
)

export const exportClinicalNoteRequested = createAction(
	PatientClinicalNoteActionTypes.ExportClinicalNoteRequested,
	props<{ clinicalNoteId: string, clinicalNoteVersion: number, documentInstanceVersion: number, name: string }>()
)

export const unlockClinicalNoteRequested = createAction(
	PatientClinicalNoteActionTypes.UnlockClinicalNoteRequested,
	props<{ reason: string }>()
)

export const unlockClinicalNoteCompleted = createAction(
	PatientClinicalNoteActionTypes.UnlockClinicalNoteCompleted
)

export const exportClinicalNoteCompleted = createAction(
	PatientClinicalNoteActionTypes.ExportClinicalNoteCompleted
)

export const emailClinicalNoteRequested = createAction(
	PatientClinicalNoteActionTypes.EmailClinicalNoteRequested,
	props<{ clinicalNoteId: string, clinicalNoteVersion: number, documentInstanceVersion: number, emailMessage: EmailMessage, attachmentNameWithoutExtension: string }>()
)

export const emailClinicalNoteCompleted = createAction(
	PatientClinicalNoteActionTypes.EmailClinicalNoteCompleted
)

export const updateClinicalNoteNameRequested = createAction(
	PatientClinicalNoteActionTypes.UpdateClinicalNoteNameRequested,
	props<{ clinicalNoteId: string, name: string }>()
);

export const updateClinicalNoteNameCompleted = createAction(
	PatientClinicalNoteActionTypes.UpdateClinicalNoteNameCompleted
);

export const setClinicalNoteDocumentWidgetValueRequested = createAction(
	PatientClinicalNoteActionTypes.SetClinicalNoteDocumentWidgetValueRequested,
	props<{ documentInstanceId: string, widgetId: number, value: any }>()
)

export const setClinicalNoteDocumentWidgetValueCompleted = createAction(
	PatientClinicalNoteActionTypes.SetClinicalNoteDocumentWidgetValueCompleted
)

export const attachmentUploadInitiated = createAction(
	PatientClinicalNoteActionTypes.AttachmentUploadInitiated,
	props<{ id: string, name: string, createdDate: string }>()
)

export const attachmentUploadProgressed = createAction(
	PatientClinicalNoteActionTypes.AttachmentUploadProgressed,
	props<{ id: string, loaded: number, total: number }>()
)

export const attachmentUploadCompleted = createAction(
	PatientClinicalNoteActionTypes.AttachmentUploadCompleted,
	props<{ id: string }>()
)

export const attachmentUploadFailed = createAction(
	PatientClinicalNoteActionTypes.AttachmentUploadFailed,
	props<{ id: string, errorMessage: string }>()
)

export const attachmentUploadsRemoved = createAction(
	PatientClinicalNoteActionTypes.AttachmentUploadsRemoved,
	props<{ ids: string[] }>()
)

export const attachmentDownloadInitiated = createAction(
	PatientClinicalNoteActionTypes.AttachmentDownloadInitiated,
	props<{ id: string }>()
)

export const attachmentDownloadCompleted = createAction(
	PatientClinicalNoteActionTypes.AttachmentDownloadCompleted
)

export const removeAttachmentRequested = createAction(
	PatientClinicalNoteActionTypes.RemoveAttachmentRequested,
	props<{ id: string }>()
)

export const removeAttachmentCompleted = createAction(
	PatientClinicalNoteActionTypes.RemoveAttachmentCompleted,
	props<{ id: string }>()
)

export const allAttachmentsSelected = createAction(
	PatientClinicalNoteActionTypes.AllAttachmentsSelected
)

export const allAttachmentsDeselected = createAction(
	PatientClinicalNoteActionTypes.AllAttachmentsDeselected
)